
const Layout1 = ({ children }) => {
  return (
    <div className="bg-[#f6f5f7]">
      {children}
    </div>
  );
};

export default Layout1;

